import { GridApi, IRowNode } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';

/** If the keyCreator and valueFormatter return the same string,
 * this renderer makes sure the same formatted value is displayed when grouping;
 */
export function GenericIdRenderer(params: CustomCellRendererProps) {
  if (isGroupColumn(params) && !isTreeNodeRow(params)) {
    return <>{params.node.key}</>;
  }
  return <>{params.valueFormatted ?? params.value}</>;
}

export function isGroupColumn(params: CustomCellRendererProps) {
  return (
    params.column?.getColDef().cellRenderer === 'agGroupCellRenderer' ||
    params.column?.getColId() === 'ag-Grid-AutoColumn'
  );
}

/** A tree node row is `node.group` like a row-group row, but carries `data` of its own — which is
 * what tells the two apart for renderers that would otherwise show `node.key`. */
export function isTreeNodeRow(params: { node?: IRowNode | null; api?: GridApi }): boolean {
  return (
    params.node?.group === true && params.node?.data != null && params.api?.getGridOption('treeData') === true
  );
}
